import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login').then((m) => m.Login),
    canActivate: [GuestGuard],
  },
  {
    path: 'signup',
    loadComponent: () => import('./signup/signup').then((m) => m.Signup),
    canActivate: [GuestGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./forgot-password/forgot-password').then((m) => m.ForgotPassword),
    canActivate: [GuestGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'u',
    loadComponent: () => import('./page/page').then((m) => m.Page),
    loadChildren: () => import('./page/page.routes').then((m) => m.pagesRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadComponent: () => import('./landing/landing').then((m) => m.Landing),
    pathMatch: 'full',
    canActivate: [GuestGuard],
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found').then((m) => m.NotFound),
  },
];
